// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__q19NV","content":"LayoutSettings_content__1_mEh"};